import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=62312ac8&scoped=true"
import script from "./AppDetails.vue?vue&type=script&lang=js"
export * from "./AppDetails.vue?vue&type=script&lang=js"
import style0 from "./AppDetails.vue?vue&type=style&index=0&id=62312ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62312ac8",
  null
  
)

export default component.exports